import { animate, state, style, transition, trigger } from '@angular/animations';
import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild, ViewChildren } from '@angular/core';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { MatSelect } from '@angular/material';
import { MatSort } from '@angular/material/sort';
import * as _ from 'lodash';
import moment from 'moment';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Message } from 'src/app/core/class/message';
import { SCREEN_SIZE } from 'src/app/core/constants/screen-size';
import { CommonService } from 'src/app/core/services/common.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { BaseComponent } from 'src/app/shared/components/base/base.component';
import { ReportService } from '../../../../../../core/services/report.service';

@Component({
  selector: 'app-timestamp-quantity-report',
  templateUrl: './timestamp-quantity-report.component.html',
  styleUrls: ['./timestamp-quantity-report.component.scss'],
  animations: [
    trigger('detailExpand', [
        state('void', style({height: '0px', minHeight: '0', visibility: 'hidden'})),
        state('*', style({height: '*', visibility: 'visible'})),
        transition('void <=> *', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ]
})
export class TimestampQuantityReportComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy {
  /**
   * Check status of document for process update
   */
  checkUpdateDocument = false;
  public warningContractQuantity = false;
  public mediaBreakpoint: any;
  public SCREEN_SIZE = SCREEN_SIZE;
  subscription: Subscription;
  enterpriseId;
  checkFocus = true;
  dateErr = '';
  mode = 8;
  isShowWarningSelectedFromDate: boolean = false;
  isShowWarningSelectedToDate: boolean = false;

  @ViewChild(MatSort, {static: false}) sort: MatSort;
  @ViewChild('myForm', {static: false}) ngForm: NgForm;
  @ViewChild('timePeriod', {static: false}) timePeriod: MatSelect;
  @ViewChildren('focusInput') focusInput;

  private _onDestroy = new Subject<void>();
  form: FormGroup;
  exportForm: FormGroup;
  showSpinner = false;
  constructor(
      private formBuilder: FormBuilder,
      private notificationService: NotificationService,
      public commonService: CommonService,
      public message: Message,
      public reportService: ReportService,
  ) {
      super(commonService, message);
  }

  ngOnInit() {
      this.enterpriseId = localStorage.getItem('enterpriseId');
      this.notificationService.subscribeErrorService();
      window.scrollTo(0, 0);

      this.form = this.formBuilder.group({
          fromDate: [null, [Validators.required]],
          toDate: [null, [Validators.required]],
          timePeriod: ['day', Validators.required]
      });
      const maxAllowCreatedTimeFrom = moment(Date.now()).subtract(31, 'd');
      this.formControls.toDate.setValue(moment(Date.now()).format('YYYY-MM-DD'));
      this.formControls.fromDate.setValue(maxAllowCreatedTimeFrom.format('YYYY-MM-DD'));
      this.formControls.timePeriod.valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(value => {
          if (value != null) {
              const currentToDate = moment(this.formControls.toDate.value);
              let maxAllowCreatedTimeTo;
              if (value === 'day') {
                  maxAllowCreatedTimeTo = moment(this.formControls.fromDate.value).add(31, 'd');
              } else if (value === 'week') {
                  maxAllowCreatedTimeTo = moment(this.formControls.fromDate.value).add(10, 'weeks').subtract(1, 'd');
              } else if (value === 'month') {
                  maxAllowCreatedTimeTo = moment(this.formControls.fromDate.value).add(12, 'months').subtract(1, 'd');
              }
              if (!currentToDate.isBetween(moment(this.formControls.fromDate.value), maxAllowCreatedTimeTo, undefined, '[]')) {
                  this.formControls.toDate.setValue(maxAllowCreatedTimeTo.format('YYYY-MM-DD'));
              }
          }
      });
  }

  ngAfterViewInit(page: number = 0) {
      setTimeout(_ => this.focusInput.first.nativeElement.focus());
  }

  ngOnDestroy() {
      this.notificationService.unsubscribeErrorService();
  }

  /**
   * Get data when init
   */
  loadData() {
  }

  onExportReport() {
      if (this.form) {
          this.exportForm = _.cloneDeep(this.form);
      }
  }

  get formControls() {
      return this.form.controls;
  }

  changeDatePickerFromDate(event) {
      this.isShowWarningSelectedToDate = false;
      this.isShowWarningSelectedFromDate = false;
      if (event.value != null) {
          const timePeriod = this.formControls.timePeriod.value;
          const currentToDate = moment(this.formControls.toDate.value);
          let maxAllowCreatedTimeTo;
          if (timePeriod === 'day') {
              maxAllowCreatedTimeTo = moment(event.value).add(31, 'd');
          } else if (timePeriod === 'week') {
              maxAllowCreatedTimeTo = moment(event.value).add(10, 'weeks').subtract(1, 'd');
          } else if (timePeriod === 'month') {
              maxAllowCreatedTimeTo = moment(event.value).add(12, 'months').subtract(1, 'd');
          }
          if (!currentToDate.isBetween(moment(event.value), maxAllowCreatedTimeTo, undefined, '[]')) {
              this.formControls.toDate.setValue(maxAllowCreatedTimeTo.format('YYYY-MM-DD'));
              // this.isShowWarningSelectedFromDate = true;
          }
      }
  }

  changeDatePickerToDate(event) {
      this.isShowWarningSelectedToDate = false;
      this.isShowWarningSelectedFromDate = false;
      if (event.value != null) {
          const timePeriod = this.formControls.timePeriod.value;
          const currentFromDate = moment(this.formControls.fromDate.value);
          let maxAllowCreatedTimeFrom;
          if (timePeriod === 'day') {
              maxAllowCreatedTimeFrom = moment(event.value).subtract(31, 'd');
          } else if (timePeriod === 'week') {
              maxAllowCreatedTimeFrom = moment(event.value).subtract(10, 'weeks').add(1, 'd');
          } else if (timePeriod === 'month') {
              maxAllowCreatedTimeFrom = moment(event.value).subtract(12, 'months').add(1, 'd');
          }
          if (!currentFromDate.isBetween(maxAllowCreatedTimeFrom, moment(event.value), undefined, '[]')) {
              this.formControls.fromDate.setValue(maxAllowCreatedTimeFrom.format('YYYY-MM-DD'));
              // this.isShowWarningSelectedToDate = true;
          }
      }
  }

  getErrorDateMessageRange(pickerInput: string, isExpired?: boolean): string {
    if (!pickerInput || pickerInput === '') {
      return null;
    }
    return this.message.getMessage('validation.format_of_date_consumption');
  }

  filterForm(event: any){
      console.log(event);
      // this.formControls.timePeriod.setValue(event.timePeriod);

      this.form.setValue({
          fromDate:  moment(event.totalReportSearch.fromDate).format('YYYY-MM-DD'),
          toDate: moment(event.totalReportSearch.toDate).format('YYYY-MM-DD'),
          timePeriod: event.totalReportSearch.timePeriod,
      });
      window.scrollTo(0, 0);
  }
}
